import { type TruckLoad, truckLoadText, truckSvg } from "./truckLoad";

/** The truck load after the open stop, in the stop box of the route map (rule U-27). */
export function TruckLoadLine({ load, capacity }: { load: TruckLoad; capacity: number }) {
  return (
    <p className={load.share > 1 ? "truck-load over" : "truck-load"} data-testid="truck-load" data-share={load.share.toFixed(2)}>
      <span className="truck-load-icon" aria-hidden="true" dangerouslySetInnerHTML={{ __html: truckSvg(load.share) }} />
      <span>{truckLoadText(load, capacity)}</span>
    </p>
  );
}
